var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarvinEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6782 3.5328L10.4628 0.3214C10.2552 0.114 9.9794 0 9.686 0C9.6855 0 9.685 0 9.6845 0C9.3906 0.0005 9.1149 0.1154 8.9077 0.3234L0.357696 8.9097C0.154996 9.1137 0.0417956 9.3837 0.0387956 9.6699L9.56332e-05 12.8901C-0.00380437 13.1899 0.111696 13.4718 0.325296 13.683C0.532896 13.888 0.805796 14 1.0962 14C1.105 14 1.1139 14 1.1227 14L4.393 13.9276C4.6771 13.9213 4.9445 13.8073 5.1453 13.6062L13.6782 5.0839C13.8859 4.8765 14 4.6011 14 4.3081C14 4.0156 13.8859 3.7402 13.6782 3.5328ZM4.3705 12.9257L1.1002 12.9981L1.0032 12.9022L1.0419 9.6816L7.6912 2.9742L11.0272 6.3064L4.3705 12.9257ZM12.9689 4.3756L11.7378 5.5997L8.3968 2.2623L9.6188 1.0296H9.7535L12.9689 4.241C13.0008 4.2729 13.0008 4.3438 12.9689 4.3756Z",
    fill: "#626161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarvinEditIcon);
export default __webpack_public_path__ + "static/media/marvinEditIcon.ccf88db71436cafbd2507517cc546729.svg";
export { ForwardRef as ReactComponent };